import * as React from "react";
import { gql, graphql, ChildProps } from "react-apollo";
import { Button, Typography } from "@material-ui/core";
import { RouteComponentProps, withRouter } from "react-router";
import withDialog, { DialogProp } from "app/utils/withDialog";
import handleMutationError from "app/utils/handleMutationError";

type MutationResult = {
  ticket_event_activate: {
    id: string;
    name: string;
    status: string;
    external_reference: string;
  };
};

type Props = ChildProps<
  {
    id: string;
    reloadData: () => void;
    redirectPath: string;
  } & DialogProp &
    RouteComponentProps,
  MutationResult
>;

class TicketEventApproveButton extends React.Component<Props> {
  approve() {
    this.props.dialog.prompt({
      content: (
        <div>
          <Typography
            variant="h6"
            component="h5"
            style={{ marginBottom: "20px" }}
          >
            Approve this event?
          </Typography>
          <Typography variant="body1">
            This action will activate the event.
          </Typography>
        </div>
      ),
      buttons: [
        {
          label: "Approve",
          action: this.confirmApprove.bind(this),
        },
        {
          label: "Cancel",
        },
      ],
    });
  }

  confirmApprove() {
    this.props
      .mutate({
        variables: {
          ticket_event_id: this.props.id,
        },
      })
      .then(() => {
        this.props.reloadData();
      })
      .catch((error) => error && handleMutationError(error));
  }

  render() {
    return (
      <Button
        style={{
          backgroundColor: "#4d5a86",
          color: "white",
          minWidth: "140px",
          height: "36px",
          fontSize: "13px",
          fontWeight: 500,
        }}
        onClick={() => this.approve()}
      >
        Approve
      </Button>
    );
  }
}

const withApproveMutation = graphql<MutationResult, Props>(
  gql`
    mutation ActivateTicketEvent($ticket_event_id: ID!) {
      ticket_event_activate(ticket_event_id: $ticket_event_id) {
        id
        name
        status
        external_reference
      }
    }
  `
);

export default withRouter(
  withDialog(withApproveMutation(TicketEventApproveButton))
);
